import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Form fields
  action: "post", // "post" or "profile"
  isPostInquiry: null,
  preferDirectContact: null,
  message: "",
  timeline: "",
  wantDirectContact: null,
  name: "",
  email: "",
  mobile: "",
  
  // Profile action specific fields
  serviceType: "",
  profileMessage: "",
  profileImages: "", // Store stringified profile images for form submission
  
  // Additional fields
  senderId: null,
  postData: null,
  profileData: null,
  
  // UI state
  currentStep: 1,
  isSubmitting: false,
  showConfirmation: false,
  images: "", // Store stringified images for UI display (Redux serialization requirement)
};

const inquiryFormSlice = createSlice({
  name: "inquiryForm",
  initialState,
  reducers: {
    setField: (state, action) => {
      return { ...state, ...action.payload };
    },
    setStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setSubmitting: (state, action) => {
      state.isSubmitting = action.payload;
    },
    setConfirmation: (state, action) => {
      state.showConfirmation = action.payload;
    },
    setImages: (state, action) => {
      state.images = action.payload;
    },
    setAction: (state, action) => {
      state.action = action.payload;
      // Reset step when action changes
      state.currentStep = 1;
    },
    setPostData: (state, action) => {
      state.postData = action.payload;
    },
    setProfileData: (state, action) => {
      state.profileData = action.payload;
    },
    resetInquiryForm: () => initialState,
  },
});

export const { 
  setField, 
  setStep, 
  setSubmitting, 
  setConfirmation, 
  setImages, 
  setAction,
  setPostData,
  setProfileData,
  resetInquiryForm 
} = inquiryFormSlice.actions;

export default inquiryFormSlice.reducer;
